import * as enums from "../store/enums"

export default {
  methods: {
    /**
     * 根据用户额度和身份计算买qb价格
     * @param buyQuantity 购买数量
     * @param vipIdentity 用户身份,是否会员
     * @param isQQwalletBindingCard 是否绑卡
     * @param provideUin 承载号码
     * @param qbRechargeDiscountLeftQuota qb折扣剩余额度
     * @param qbRechargeSpecialDiscount qb特殊折扣(vip是92折,svip是91折,绑卡用户有300额度的92折)
     * @param qbRechargeDefaultDiscount qb默认折扣(一般94折)
     * @param openid 当前系统的登陆号码
     * @returns {number}
     */
    calcQBDiscountPrice: function ({
      buyQuantity,
      vipIdentity,
      isQQwalletBindingCard,
      provideUin,
      qbRechargeDiscountLeftQuota,
      qbRechargeSpecialDiscount,
      qbRechargeDefaultDiscount,
      openid,
      loginOpenidUin
    }) {
      //会员,超会,普通用户绑卡给自己买都需要计算额度
      if (vipIdentity > enums.USER_VIP_GRADE.COMMON || (isQQwalletBindingCard && (provideUin == openid || provideUin == loginOpenidUin))) {
        if (qbRechargeDiscountLeftQuota > 0) {
          if (buyQuantity > qbRechargeDiscountLeftQuota) {
            //混合折扣
            return (
              (qbRechargeDiscountLeftQuota * qbRechargeSpecialDiscount) / 100 +
              ((buyQuantity - qbRechargeDiscountLeftQuota) * qbRechargeDefaultDiscount) / 100
            )
          } else {
            return (buyQuantity * qbRechargeSpecialDiscount) / 100
          }
        } else {
          return (buyQuantity * qbRechargeDefaultDiscount) / 100
        }
      } else {
        return (buyQuantity * qbRechargeDefaultDiscount) / 100
      }
    }
  }
}
